import styled from 'styled-components';

export const FormStyle = styled.form`
    display: flex;
    width: 400px;
    padding: 10px;
    gap: 20px;
    flex-wrap: wrap;
    border: 2px solid #31d37a;
`;